var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgEth(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_x0020_1",
    xmlns: "http://www.w3.org/2000/svg",
    width: 12.632,
    height: 20.573,
    viewBox: "0 0 12.632 20.573",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "_1421394342400"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_106029",
    "data-name": "Group 106029"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_49317",
    "data-name": "Path 49317",
    d: "M383.638,0,383.5.469v13.6l.138.138,6.314-3.732Z",
    transform: "translate(-377.324)",
    fill: "#343434"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_49318",
    "data-name": "Path 49318",
    d: "M6.314,0,0,10.477l6.314,3.732V0Z",
    fill: "#8c8c8c"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_49319",
    "data-name": "Path 49319",
    d: "M387.318,728.62l-.078.095v4.846l.078.227,6.318-8.9Z",
    transform: "translate(-381.003 -713.216)",
    fill: "#3c3c3b"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_49320",
    "data-name": "Path 49320",
    d: "M6.314,733.788V728.62L0,724.89Z",
    transform: "translate(0 -713.216)",
    fill: "#8c8c8c"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_49321",
    "data-name": "Path 49321",
    d: "M392.07,478.932l6.314-3.732-6.314-2.87Z",
    transform: "translate(-385.756 -464.723)",
    fill: "#141414"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_49322",
    "data-name": "Path 49322",
    d: "M0,475.2l6.314,3.732v-6.6Z",
    transform: "translate(0 -464.723)",
    fill: "#393939"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEth);
export default __webpack_public_path__ + "static/media/eth.a73937f73dd746847e565434d759c919.svg";
export { ForwardRef as ReactComponent };